import {
  UPDATE_GAME_DETAIL_DASHBOARD_LOADING,
  GET_GAME_DETAIL_DASHBOARD,
  UPDATE_REQUEST_DASHBOARD,
  UPDATE_REPORT_LIST_PAGINATION,
  CLEAR_REQUEST_DASHBOARD
} from "../actions/types"

const initialState = {
  gameDetailDashboard: {
    name: '',
    game_start_date: '',
    game_status: true,
    game_replay: true,
    game_verify: true,
    game_end_date: '',
    reward_qty_out: 0,
    reward_qty: 0,
    reportTable: [],
    rewardOutGraph: [],
    rewardPerDayGraph: [],
    total: 0
  },
  requestGameDetailDashboard: {
    name: '',
    play_date: [],
    redeem_date: [],
    status: 0
  },
  pagination: {
    currentPage: 0,
    perPage: 10
  },
  loading: false
}

const gameDetailDashboard = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case UPDATE_REQUEST_DASHBOARD:
      return {
        ...state,
        requestGameDetailDashboard: {
          ...state.requestGameDetailDashboard,
          [payload.name]: payload.value
        }
      }
    case GET_GAME_DETAIL_DASHBOARD:
      return {
        ...state,
        gameDetailDashboard: {
          name: payload.name,
          game_start_date: payload.game_start_date,
          game_status: payload.game_status,
          game_replay: payload.game_replay,
          game_verify: payload.game_verify,
          game_end_date: payload.game_end_date,
          reward_qty_out: payload.reward_qty_out,
          reward_qty: payload.reward_qty,
          reward_out_graph: payload.rewardOutGraph,
          rewardPerDayGraph: payload.rewardPerDayGraph,
          reportTable: payload.reportTable,
          total: payload.total
        }
      }
    case UPDATE_REPORT_LIST_PAGINATION:
      return {
        ...state,
        pagination: payload
      }
      case UPDATE_GAME_DETAIL_DASHBOARD_LOADING:
    return {
      ...state,
      loading: payload
    }
    case CLEAR_REQUEST_DASHBOARD:
      return {
        ...state,
        requestGameDetailDashboard: initialState.requestGameDetailDashboard
      }
    default:
      return state
  }
}

export default gameDetailDashboard